import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { WidgetMultiQuestionPreviewV0Dto } from './models/widget-multi-question-preview-v0.dto';
import { WidgetUtils } from '../../widget.utils';
import { Observable, of } from 'rxjs';
import { WidgetDialogService } from '../../../services/widget-dialog.service';
import {
  MultiQuestionSelectItem,
  WidgetMultiQuestionResponseV0Dto,
  WidgetMultiQuestionResponseV0DtoWrapper
} from './models/widget-multi-question-response-v0.dto';
import { ND, WProperties } from '@pt/pt-models';
import { TranslateService } from '@ngx-translate/core';
import {
  WidgetRiskAssessmentV0Implemented
} from '../../widget-risk-assessment/v0/models/widget-risk-assessment-v0-args.dto';
import { WidgetMultiQuestionValueV0 } from './models/widget-multi-question-value-v0.dto';

@Component({
  selector: 'pt-widget-multi-question-v0-editor',
  template: `
    <table class="table" *ngIf="show && currentData">
      <tbody>
        <ng-container *ngIf="currentQuestions.length === 0">
          <tr *ngIf="data?.valutation && showEvalQuestion">
            <td colspan="3" class="p-0">
              <div class="question-container">
                <div class="missing-question">
                  Attenzione, non sono presenti domande
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        <ng-container *ngFor="let question of currentQuestions; let i = index">
          <tr
            [ngClass]="{
              'widget-row-striped': i % 2 === 0,
              'border-bottom-transparent': question?.type === 'CHECKBOX'
            }"
          >
            <td style="width: 100px; min-width: 100px; padding: 8px;">
              {{ question.label }}
            </td>
            <td style="padding: 0;">
              <div class="w-col-2">
                <div class="description">
                  <span
                    [innerHTML]="question.question | formatNewlineToHtml"
                  ></span>
                  <pt-w-help [help]="question.help"></pt-w-help>
                </div>
                <div class="action" *ngIf="question.subTitle">
                  <div
                    class="badge-subtitle-ellipse"
                    container="body"
                    ngbTooltip="{{ question.subTitle }}"
                  >
                    {{ question.subTitle }}
                  </div>
                </div>
              </div>
              <!--end w-col-2-->
            </td>
            <td>
              <ng-container [ngSwitch]="question?.type">
                <div class="w-col-3" *ngSwitchCase="'RADIO_BUTTON'">
                  <ng-select
                    class="wmq-select"
                    appendTo="body"
                    [items]="question.currentAnswers"
                    [ngClass]="{
                      'ng-select-empty':
                        question.answers?.length ===
                        question?.checkedValue?.value
                    }"
                    [ngModel]="question.checkedValue"
                    (ngModelChange)="ngSelectChangeRowValue($event, question)"
                    [searchable]="true"
                    [clearable]="false"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      {{ item.label }}
                    </ng-template>

                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                    >
                      <div
                        container="body"
                        class="text-truncate"
                        ngbTooltip="{{ item.label }}"
                      >
                        {{ item.label }}
                      </div>
                    </ng-template>
                  </ng-select>

                  <div
                    class="widget-btn-link wmq-note"
                    *ngIf="showNote"
                    (click)="clickNote(question)"
                  >
                    {{
                      currentData.header.note
                        ? currentData.header.note
                        : ('TITLE.NOTES' | translate)
                    }}
                  </div>
                </div>

                <div
                  class="w-col-3 mt-1"
                  *ngSwitchCase="'CHECKBOX'"
                  [ngClass]="[question.answers.length > 5 ? 'wmq-wrap' : '']"
                >
                  <div
                    class="widget-btn-link wmq-note"
                    *ngIf="showNote"
                    (click)="clickNote(question)"
                  >
                    {{
                      currentData.header.note
                        ? currentData.header.note
                        : ('TITLE.NOTES' | translate)
                    }}
                  </div>
                </div>

                <div
                  class="w-col-3 d-flex mt-1 mb-3"
                  *ngSwitchCase="'TEXT'"
                  style="margin-left: auto;margin-right: 5px;}"
                >
                  <textarea
                    (click)="
                      clickText(
                        question.uuid,
                        question.textValue,
                        question.question
                      )
                    "
                    [value]="question.textValue ? question.textValue : ''"
                    class="form-control wmq-textarea"
                    rows="3"
                  >
                  </textarea>
                  <div
                    class="widget-btn-link wmq-note"
                    *ngIf="showNote"
                    (click)="clickNote(question)"
                  >
                    {{
                      currentData.header.note
                        ? currentData.header.note
                        : ('TITLE.NOTES' | translate)
                    }}
                  </div>
                </div>
              </ng-container>
            </td>
          </tr>
          <tr
            *ngIf="question?.type === 'CHECKBOX'"
            [ngClass]="{ 'widget-row-striped': i % 2 === 0 }"
          >
            <td></td>
            <td colspan="2" class="p-0">
              <div
                class="widget-row-checkbox d-flex flex-column"
                style="margin-left: 15px;"
                *ngIf="question?.type === 'CHECKBOX'"
              >
                <div
                  class="form-check multiquestion-form-check"
                  [ngClass]="[question?.answers.length <= 5 ? 'w-100' : '']"
                  *ngFor="let o of question.answers; let iResponse = index"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    (change)="clickCheckbox(iResponse, question.uuid, $event)"
                    [value]="iResponse"
                    [checked]="
                      includeCheckbox(question.checkboxValue, iResponse)
                    "
                    [id]="uniqueId + question.uuid + iResponse"
                  />
                  <label
                    class="form-check-label"
                    [htmlFor]="uniqueId + question.uuid + iResponse"
                  >
                    {{ o }}
                  </label>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="data?.valutation && showEvalQuestion">
          <td colspan="3" class="p-0">
            <div class="valutation">
              <div class="valutation-question">{{ data?.valutation.name }}</div>
              <div class="valutation-response">
                <ng-select
                  #ngSelectComponent
                  [searchable]="true"
                  [clearable]="true"
                  [ngClass]="responseEvaluationCss"
                  [(ngModel)]="responseEvaluation"
                  class="wmq-select"
                  bindValue="value"
                  bindLabel="label"
                  appendTo="body"
                  (ngModelChange)="
                    setValutationResponse($event); ngSelectComponent.blur()
                  "
                >
                  <ng-option
                    *ngFor="
                      let o of data?.valutation.values;
                      let iResponse = index
                    "
                    [value]="iResponse"
                  >
                    <span [style.color]="o.color || '#000000'">{{
                      o.label
                    }}</span>
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  `,
  styleUrls: [`./widget-multi-question-v0-editor.component.scss`],
  encapsulation: ViewEncapsulation.None,
})
export class WidgetMultiQuestionV0EditorComponent implements OnChanges {
  @Input() data: WidgetMultiQuestionPreviewV0Dto;
  @Input() show: boolean;
  @Input() properties?: WProperties;
  @Input() noResponseLabel: string;
  @Output() changeValue = new EventEmitter<WidgetMultiQuestionValueV0>();

  currentData: WidgetMultiQuestionPreviewV0Dto;
  uniqueId = WidgetUtils.generateId('WMQ_');
  responseEvaluation = null;
  responseEvaluationCss = '';
  ND = ND;
  public showNote = true;
  public showEvalQuestion = true;

  currentQuestions: WidgetMultiQuestionResponseV0DtoWrapper[];

  constructor(
    private widgetDialogService: WidgetDialogService,
    private translateService: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.reloadWidget(JSON.parse(JSON.stringify(changes.data.currentValue)));
    }
    if (this.properties && this.properties.skipNote) {
      this.showNote = false;
    } else {
      this.showNote = true;
    }
    if (this.properties && this.properties.skipEvalQuestion) {
      this.showEvalQuestion = false;
    } else {
      this.showEvalQuestion = true;
    }
  }

  clickNote(row: WidgetMultiQuestionResponseV0Dto) {
    const noteTitle: Observable<string> = this.currentData.header.note
      ? of(this.currentData.header.note)
      : this.translateService.stream('TITLE.NOTES');
    const dialog = this.widgetDialogService.runTextArea(
      noteTitle,
      row?.note,
      true
    );
    dialog.subscribe((value) => {
      this.currentQuestions.forEach((f) => {
        if (f.uuid === row.uuid) {
          f.note = value;
        }
      });
      this.currentData.questions = JSON.parse(
        JSON.stringify(this.currentQuestions)
      );
      this.emitChange();
    });
  }

  includeCheckbox(list: number[], value: number): boolean {
    return (
      !!list &&
      list.length &&
      value !== null &&
      value !== undefined &&
      list.includes(value)
    );
  }

  setValutationResponse(iResponse: number) {
    this.responseEvaluation = iResponse;
    this.responseEvaluationCss = this.cssResponseEvaluation(
      this.responseEvaluation
    );
    this.currentData.valutation.checkedValueIndex = iResponse;
    this.emitChange();
  }

  ngSelectChangeRowValue(
    implementedValueSelected: WidgetRiskAssessmentV0Implemented,
    row: WidgetMultiQuestionResponseV0Dto
  ) {
    this.currentData?.questions.forEach((f) => {
      if (f.uuid === row.uuid) {
        if (implementedValueSelected.label === this.noResponseLabel) {
          f.radioValue = undefined;
        } else {
          f.radioValue = implementedValueSelected.value;
        }
      }
    });
    this.emitChange();
  }

  clickCheckbox(iResponse: number, questionUuid: string, event: Event) {
    const checked = (event.target as HTMLInputElement)?.checked;
    this.currentData?.questions?.forEach(
      (question: WidgetMultiQuestionResponseV0Dto) => {
        if (!question.checkboxValue) {
          question.checkboxValue = [];
        }
        if (question.uuid === questionUuid) {
          question.checkboxValue = question.checkboxValue.filter(
            (value) => value !== iResponse
          );
          if (checked) {
            question.checkboxValue.push(iResponse);
          }
        }
      }
    );
    this.emitChange();
  }

  clickText(questionUuid: string, value: string, question: string) {
    const dialog = this.widgetDialogService.runTextArea(
      of(question),
      value ? value : '',
      true
    );
    dialog.subscribe((value) => {
      this.currentData?.questions?.forEach(
        (question: WidgetMultiQuestionResponseV0Dto) => {
          if (question.uuid === questionUuid) {
            question.textValue = value;
          }
        }
      );
      this.emitChange();
    });
  }

  reset(currentQuestion: WidgetMultiQuestionResponseV0Dto) {
    this.currentData?.questions?.forEach(
      (question: WidgetMultiQuestionResponseV0Dto) => {
        if (currentQuestion.uuid === question.uuid) {
          question.radioValue = undefined;
        }
      }
    );
    this.emitChange();
  }

  isChecked(question: WidgetMultiQuestionResponseV0Dto): boolean {
    return !!this.currentData?.questions?.find(
      (r) => question.uuid === r.uuid && r.radioValue >= 0
    );
  }

  clickRadio(iResponse: number, questionUuid: string) {
    this.currentData?.questions?.forEach(
      (question: WidgetMultiQuestionResponseV0Dto) => {
        if (question.uuid === questionUuid) {
          question.radioValue = iResponse;
        }
      }
    );
    this.emitChange();
  }

  private reloadWidget(data: WidgetMultiQuestionPreviewV0Dto) {
    this.currentData = data;
    this.responseEvaluationCss = '';
    this.responseEvaluation = this.currentData?.valutation?.checkedValueIndex;
    this.responseEvaluationCss = this.cssResponseEvaluation(
      this.currentData?.valutation?.checkedValueIndex as number
    );
    this.currentQuestions = this.currentData.questions.map((m) => {
      const currentAnswers = this.createAnswers(
        m.answers,
        this.noResponseLabel,
        m.radioValue
      );
      return {
        ...m,
        checkedValue: currentAnswers.find((c) => c.checked),
        currentAnswers,
      };
    });
  }

  private cssResponseEvaluation(iResponse: number) {
    if (iResponse !== null && iResponse !== undefined) {
      switch (iResponse) {
        case 0:
          return 'very-high';
        case 1:
          return 'high';
        case 2:
          return 'medium-high';
        case 3:
          return 'medium';
        case 4:
          return 'medium-low';
        case 5:
          return 'low';
      }
    }
    return '';
  }

  private emitChange() {
    const response: WidgetMultiQuestionValueV0 = {
      answers: [],
      evalAnswer: this.responseEvaluation,
    };
    this.currentData.questions.forEach(
      (question: WidgetMultiQuestionResponseV0Dto) => {
        switch (question?.type) {
          case 'TEXT':
            response.answers.push({
              uuid: question?.uuid,
              value: question?.textValue,
              note: question?.note,
            });
            break;

          case 'CHECKBOX':
            response.answers.push({
              uuid: question?.uuid,
              value: question?.checkboxValue,
              note: question?.note,
            });
            break;
          case 'RADIO_BUTTON':
            response.answers.push({
              uuid: question?.uuid,
              value: question?.radioValue,
              note: question?.note,
            });
            break;
        }
      }
    );
    this.changeValue.emit(response);
    this.reloadWidget(JSON.parse(JSON.stringify(this.currentData)));
  }

  private createAnswers(
    answers: string[],
    noResponseLabel: string,
    radioValue?: number
  ): MultiQuestionSelectItem[] {
    const response: MultiQuestionSelectItem[] = [];
    let addSelected = false;
    answers?.forEach((label: string, index: number) => {
      if (index === radioValue) {
        addSelected = true;
        const item: MultiQuestionSelectItem = {
          label,
          value: index,
          checked: true,
        };
        response.push(item);
      } else {
        const item: MultiQuestionSelectItem = {
          label,
          value: index,
          checked: false,
        };
        response.push(item);
      }
    });
    const item: MultiQuestionSelectItem = {
      label: noResponseLabel,
      value: response.length,
      checked: !addSelected,
    };
    response.push(item);
    return response;
  }
}
